import React from "react";
import TicTacToe from "./tictactoe";
import MemoryGame from "./MemoryGame";
import ImagePuzzle from "./ImagePuzzle";

export default class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      game: null,
      menu: {}
    };
  }

  componentDidMount() {
    fetch("https://opensheet.elk.sh/1bVyKkZGwHOVHoxLULVa6R19JEuGiC3wVV_pxNPqk1cc/Menu")
      .then(res => res.json())
      .then(data => {
        const menu = this.convertToMenu(data);
        this.setState({ menu });
      })
      .catch(() => {
        console.log("Error loading menu");
      });
  }

  // ✅ Convert API → grouped menu
  convertToMenu = (data) => {
    const menu = {};

    data.forEach((row) => {
      if (!row.section || !row.name) return;

      const section = row.section.toLowerCase().trim();

      if (!menu[section]) menu[section] = [];

      menu[section].push({
        id: Math.random(),
        name: row.name,
        mini: row.mini || "",
        regular: row.regular || "",
        large: row.large || "",
        single: row.single || "",
        full: row.full || "",
        price: row.price || ""
      });
    });

    return menu;
  };

  render() {
    return (
      <div>
        <div className="wrapper">

          <section className="bread-crumb-container">
            <div className="bread-crumb-content">
              <h2>Menu</h2>
            </div>
          </section>

          

          <div className="main-part" style={{"marginTop" : '0px'}}>

            <div
            className="game-banner"
            onClick={() => this.setState({ open: true })}>
            <div className="game-banner-content">
              <div className="game-banner-left">
                <h2>🎮 Play & Win Rewards</h2>
                <p>Enjoy games while waiting for your food</p>
              </div>

              <div className="game-banner-btn">
                Play Now →
              </div>
            </div>
          </div>

            <section className="elite-menu">

              <div className="elite-header">
                <h1>Bagara & Biryani</h1>
                <p>Authentic Hyderabadi Cuisine</p>
              </div>

              <div className="elite-grid">

                {Object.keys(this.state.menu).map((section) => {

                  const items = this.state.menu[section];

                  // ✅ AUTO DETECT COLUMNS
                  const activeColumns = Array.from(
                    new Set(
                      items.flatMap(item =>
                        Object.keys(item).filter(
                          key =>
                            key !== "id" &&
                            key !== "name" &&
                            item[key]
                        )
                      )
                    )
                  );

                  return (
                    <div className="elite-card" key={section}>

                      <h2 className="elite-section-title">
                        {section.replace("_", " ").toUpperCase()}
                      </h2>

                      {/* ✅ Dynamic Header */}
                      <div className="elite-item elite-header-row">
                        <div className="elite-left">Item</div>

                        <div className="elite-right">
                          {activeColumns.map(col => (
                            <span key={col}>
                              {col.charAt(0).toUpperCase() + col.slice(1)}
                            </span>
                          ))}
                        </div>
                      </div>

                      {/* ✅ Items */}
                      {items.map((item) => (
                        <div className="elite-item" key={item.id}>

                          <div className="elite-left">
                            {item.name}
                          </div>

                          <div className="elite-right">
                            {activeColumns.map(col => (
                              <span key={col}>
                                {item[col] ? `₹${item[col]}` : "-"}
                              </span>
                            ))}
                          </div>

                        </div>
                      ))}

                    </div>
                  );
                })}

              </div>

            </section>

            <div className="map-outer">
              <div id="truck-locator"></div>
            </div>

          </div>
        </div>

        

        {/* 🎮 Popup */}
        {/* {this.state.open && (
          <div
            className="popup-overlay"
            onClick={() => this.setState({ open: false, game: null })}
          >
            <div
              className="popup-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="close-btn"
                onClick={() => this.setState({ open: false, game: null })}
              >
                ✕
              </button>

              {!this.state.game && (
                <div className="game-select">
                  <h3>Select a Game</h3>

                  <button onClick={() => this.setState({ game: "ttt" })}>
                    🎮 Tic Tac Toe
                  </button>

                  <button onClick={() => this.setState({ game: "memory" })}>
                    🧠 Memory Game
                  </button>

                  <button onClick={() => this.setState({ game: "imgpuzzle" })}>
                    🖼 Image Puzzle
                  </button>
                </div>
              )}

              {this.state.game === "ttt" && <TicTacToe />}
              {this.state.game === "memory" && <MemoryGame />}
              {this.state.game === "imgpuzzle" && <ImagePuzzle />}
            </div>
          </div>
        )} */}

          {this.state.open && (
  <div
    className="popup-overlay"
    onClick={() => this.setState({ open: false, game: null })}
  >
    <div
      className="popup-content new-popup"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="close-btn"
        onClick={() => this.setState({ open: false, game: null })}
      >
        ✕
      </button>

      {!this.state.game && (
        <div className="game-select-new">
          <h2>🎮 Choose Your Game</h2>
          <p>Win rewards while your food is prepared</p>

          <div className="game-grid">
            <div onClick={() => this.setState({ game: "ttt" })} className="game-card">
              <span>❌⭕</span>
              <h4>Tic Tac Toe</h4>
            </div>

            <div onClick={() => this.setState({ game: "memory" })} className="game-card">
              <span>🧠</span>
              <h4>Memory Game</h4>
            </div>

            <div onClick={() => this.setState({ game: "imgpuzzle" })} className="game-card">
              <span>🖼</span>
              <h4>Puzzle</h4>
            </div>
          </div>
        </div>
      )}

      {this.state.game && (
        <div className="game-container">
          <button
            className="back-btn"
            onClick={() => this.setState({ game: null })}
          >
            ← Back
          </button>

          {this.state.game === "ttt" && <TicTacToe />}
          {this.state.game === "memory" && <MemoryGame />}
          {this.state.game === "imgpuzzle" && <ImagePuzzle />}
        </div>
      )}
    </div>
  </div>
)}

      </div>
    );
  }
}